import { pluralizeName } from '@libs/NwUtils';

const isBookingEvent = (typeName) => {
    return typeName.toLowerCase() === 'casting' || typeName.toLowerCase() === 'job' || typeName.toLowerCase() === 'ext';
};

const isJobEvent = (typeName) => {
    return typeName.toLowerCase() === 'job' || typeName.toLowerCase() === 'ext';
};

const isJobNonExtEvent = (typeName) => {
    return typeName.toLowerCase() === 'job';
};

const isExtEvent = (typeName) => {
    return typeName.toLowerCase() === 'ext';
};

const isCastingEvent = (typeName) => {
    return typeName.toLowerCase() === 'casting';
};

const isCastingOrJobEvent = (typeName) => {
    return typeName.toLowerCase() === 'casting' || typeName.toLowerCase() === 'job';
};

const readableEventType = (typeName, plural = false) => {
    const readableNames = {
        casting: 'Casting',
        job: 'Job',
        ext: 'External Job',
        'follow-up': 'Activity',
        travel: 'Travel',
        todo: 'Task',
        'room-lodging': 'Room Lodging',
        meeting: 'Meeting',
        accommodation: 'Accommodation',
        extjob: 'Move',
    };
    const readablename = readableNames[typeName] || typeName;
    return plural ? pluralizeName(readablename) : readablename;
};

export {
    isBookingEvent,
    isJobEvent,
    isExtEvent,
    isJobNonExtEvent,
    isCastingEvent,
    isCastingOrJobEvent,
    readableEventType,
};
